<div class="echarts" echarts [options]="chartOption" style="height: 280px;"></div>